.list {
  background-color: var(--common-white);
  margin-bottom: 8px;
}
